<template>
  <div>
    <CardBase>
      <MacroSubHeader
        title="Distribuidores Indicados"
        icon="el-icon-office-building"
      >
        <template slot="actions">
          <Export/>
        </template>
      </MacroSubHeader>

      <CardBase>
        <!-- Filters -->
        <Filters :is-loading="isLoading" @dispatch="handleFilters"/>

        <el-table
          class="rounded"
          :data="data" 
          align="center" 
          border
          row-key="id"
          size="mini"
        >   
            <!-- ID -->
            <el-table-column 
              v-if="isAdm"
              label="ID" 
              width="80"
              prop="id" 
              align="left"
            >
                <div slot-scope="scope">{{ scope.row.id }}</div>
            </el-table-column>
    
            <!-- Nome -->
            <el-table-column min-width="320" label="Nome" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.nome }}</span>
                </template>
            </el-table-column>
    
            <!-- E-mail -->
            <el-table-column width="300" label="E-mail" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.email }}</span>
                </template>
            </el-table-column>

            <!-- Contato -->
            <el-table-column width="200" label="Telefone" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.telefone }}</span>
                </template>
            </el-table-column>

            <!-- Uf -->
            <el-table-column label="Cidade/Estado" width="220" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center justify-content-between" :style="{ gap: '12px' }">
                        <span>{{ scope.row.cidade }}</span>
                        <!-- - -->
                        <el-tag size="small">{{ scope.row.estado }}</el-tag>
                    </div>
                </template>
            </el-table-column>
    
            <!-- Status -->
            <el-table-column label="Status" width="140" align="left">
                <template slot-scope="scope">
                    <el-tag 
                        v-if="scope.row.status"
                        type="info" 
                        size="small"
                        :type="scope.row.status === 'IMPORTADO' 
                            ? 'success' 
                            : (scope.row.status == 'PENDENTE' ? 'warning' : 'danger')"
                    >
                        {{ scope.row.status.toUpperCase() }}
                    </el-tag>
                </template>
            </el-table-column>
    
            <!-- Analisado por -->
            <el-table-column label="Analisado por" width="250" align="left">
                <template slot-scope="scope">
                     <div 
                      v-if="scope.row.user" 
                      class="d-flex align-items-center"
                      :style="{ gap: '8px' }"
                     >
                        <el-avatar size="small">
                          {{ scope.row.user.name.charAt(0) }}
                        </el-avatar>

                        <div 
                          class="d-flex flex-column" 
                          :style="{ minWidth: 0, flex: 1 }"
                        >
                          <span 
                            class="font-weight-bold text-truncate"
                            :style="{ fontSize: '14px' }"
                          >
                            {{ scope.row.user.name }}
                          </span>
                        </div>
                      </div>
                      
                      <el-tag 
                        v-else
                        type="info" 
                        size="small"
                      >
                        Não associado
                      </el-tag>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Criado em" width="110" align="center">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.created_at) }}</span>
                    </div>
                </template>
            </el-table-column>
    
            <!-- Acoes -->
            <el-table-column 
                fixed="right"
                :width="75"
                align="right"
            >
                <div slot="header" style="width: 100%;">
                    <i class="el-icon-menu" />
                </div>
                <template slot-scope="scope">
                    <div class="d-flex justify-content-between">
                        <div :style="{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px', maxWidth: '300px' }">
                            <el-button
                                size="mini" 
                                type="primary" 
                                plain
                                :style="{ width: '100%' }"
                                @click.native.prevent="handleDistributor(scope.row.id)"
                            >
                                <i class="el-icon-right"></i>
                                <i class="el-icon-office-building"></i>
                            </el-button>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <template slot="empty">
                <el-empty description="Nenhum distribuidor indicado disponível"></el-empty>
            </template>
        </el-table>

        <!-- Paginacao -->
        <el-row class="mt-3">
            <el-col>
                <el-pagination
                  background
                  :current-page.sync="pagination.currentPage"
                  :page-sizes="pageSizes"
                  :page-size="pagination.perPage"
                  layout="total, sizes, prev, pager, next"
                  :total="total"
                  @current-change="handlePageChange"
                  @size-change="handleSizeChange"
                />
            </el-col>
        </el-row>
      </CardBase>
    </CardBase>
  
    <DistributorShowModal 
      ref="distributorShowModal" 
      @dispatchImportDistributor="handleImportDistributor"
      @dispatch="handleDispatch"
    />
  </div>
</template>

<script>
  // Components
  import {
      Card,
      Table,
      TableColumn,
      Pagination,
      Tag
  } from 'element-ui'

  import CardBase from '@/components/_macro/CardBase.vue';
  import MacroSubHeader from '@/components/_macro/MacroSubHeader.vue';

  import Filters from './Filters.vue';
  import Export from './Export.vue';
  import DistributorShowModal from './DistributorShowModal.vue';

  // Utils
  import { formatDate } from "@/util/formatters"

  // Api
  import { DistribuidorIndicadoApi } from '@/api/DistribuidorIndicadoApi.js';
  const distribuidorIndicadoApi = new DistribuidorIndicadoApi()

  export default {
    data() {
      return {
        loadingExportar: false,
        filtro: {
          status: null,
          nome: "",
          estado: null,
          de: {
            data: "",
            dataFormatada: "",
          },
          ate: {
            data: "",
            dataFormatada: "",
          },
        },
        modalImport: false,
        precadastro: {},
        distribuidor: {},

        isLoading: false,
        data: [],
        filters: null,
        pagination: {
          currentPage: 1,
          perPage: 15,
        },
        pageSizes: [15, 50, 75, 100],
        total: 0
      };
    },
    methods: {
      async fetch() {
        this.isLoading = true;

        try {
            const res = await distribuidorIndicadoApi.index({
              ...this.filters,
              ...this.pagination,
            });

            this.total = res.total;
            this.data = res.data;
        } catch (error) {
            Notification.error({
                title: 'Erro',
                message: 'Não foi possível obter os distribuidores indicados. Algo inesperado ocorreu!'
            });
        } finally {
            this.isLoading = false;
        }
      },
      exportar() {
        const vm = this;
        vm.loadingExportar = true;
        const data = {
          filtro: vm.filtro,
        };
        axios({
          method: "post",
          url: "/revendedoras_indicadas/exportar",
          responseType: "blob",
          data: data,
        })
          .then((response) => {
            let file = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            });
            let url = window.URL.createObjectURL(file);
            let a = document.createElement("a");
            a.href = url;
            a.download = Date.now() + ".xlsx";
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch((erro) => {
            console.log(erro);
            vm.$swal("Atenção", erro, "error");
          })
          .finally(() => {
            $(".loading").hide();
            vm.loadingExportar = false;
          });
      },
      handleFilters(payload) {
          this.filters = payload;
          this.fetch();
        },
      async handleDistributor(distributorId) {
        const elLoading = this.$loading({ lock: true })

        this.$refs.distributorShowModal.distributorId = distributorId;

        await this.$refs.distributorShowModal.show();

        elLoading.close()

        this.$refs.distributorShowModal.toggleModal()
      },
      handleImportDistributor() {
        this.$emit("importarDistribuidor");
      },
      async handleDispatch() {
        await this.fetch()
      },
      /*
      *Pagination 
      *
      */
      handlePageChange(page) {
          this.pagination.currentPage = page;
          this.fetch();
      },
      handleSizeChange(val) {
          this.pagination.perPage = val;
          this.pagination.currentPage = 1;
          this.fetch();
      },
      formatDate
    },
    mounted() {
        this.fetch();
    },
    computed: {
      isAdm() {
        return this.$store.getters['user/isAnyRole'](['adm']);
      },
    },
    components: {
      CardBase,
      MacroSubHeader,
      Filters,
      Export,
      DistributorShowModal,
      [Card.name]: Card,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Pagination.name]: Pagination,
      [Tag.name]: Tag,
    }
  };
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/indicados/distribuidores_indicados/Index.vue